import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PROPERTY_CATEGORIES } from '../config/ci-options.config';
import { PropertyCategory } from '../models/ci-form.model';

/**
 * Four icon cards. Changing the selection changes the whole flow downstream —
 * a plot runs four steps, an apartment five — so this sits above the stepper.
 */
@Component({
  selector: 'ci-property-type',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ci-property-type.component.html',
})
export class CiPropertyTypeComponent {
  readonly categories = PROPERTY_CATEGORIES;
  readonly selected = input.required<PropertyCategory>();
  readonly selectedChange = output<PropertyCategory>();
}
